import { SUBJECT_DATA, getSubjects } from './subjectsData';

// Gujarati stream names
export const STREAM_NAMES = {
  science: "સાયન્સ",
  commerce: "કોમર્સ",
  arts: "આર્ટ્સ"
};

// API Service Functions
export const getSubjectsByStandardAndStream = (standard, stream) => {
  return new Promise((resolve) => {
    // Simulate API delay
    setTimeout(() => {
      const subjects = getSubjects(standard, stream);
      resolve({
        success: true,
        data: subjects,
        message: "Subjects fetched successfully"
      });
    }, 300);
  });
};

export const getAllSubjectsByStandard = (standard) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const subjects = SUBJECT_DATA.filter(subject => subject.standard === standard);
      resolve({
        success: true,
        data: subjects,
        message: "All subjects for standard fetched successfully"
      });
    }, 300);
  });
};

export const getStreamNames = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        data: STREAM_NAMES,
        message: "Stream names fetched successfully"
      });
    }, 200);
  });
};

export const getSubjectById = (id) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const subject = SUBJECT_DATA.find(s => s.kram === id);
      
      if (subject) {
        resolve({
          success: true,
          data: subject,
          message: "Subject found successfully"
        });
      } else {
        resolve({
          success: false,
          data: null,
          message: "Subject not found"
        });
      }
    }, 200);
  });
};

export const getSubjectByStandardStreamAndId = (standard, stream, id) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const subject = SUBJECT_DATA.find(s => 
        s.standard === standard && 
        s.stream === stream && 
        s.kram === id
      );
      
      if (subject) {
        resolve({
          success: true,
          data: subject,
          message: "Subject found successfully"
        });
      } else {
        resolve({
          success: false,
          data: null,
          message: "Subject not found"
        });
      }
    }, 200);
  });
};

// Export constants for direct access (if needed)
export { SUBJECT_DATA };

// Default export for convenience
export default {
  getSubjectsByStandardAndStream,
  getAllSubjectsByStandard,
  getStreamNames,
  getSubjectById,
  getSubjectByStandardStreamAndId,
  SUBJECT_DATA,
  STREAM_NAMES
};
